import React, { useEffect, useRef, useState } from "react";
import { CreditCard, Money, CheckCircle, CaretDown } from "@phosphor-icons/react";

/**
 * Compact button that opens a mini popover asking payment method (Pix | Cartão).
 * On select, calls onSelect(method) where method ∈ {"pix", "credit"}.
 *
 * Props: onSelect, label, testid, variant ("green"|"white"), size ("sm"|"md")
 */
export default function PaymentMethodMenu({
  onSelect, label = "Marcar pago", testid = "mark-paid", variant = "white", size = "sm",
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const pick = (method) => {
    setOpen(false);
    onSelect?.(method);
  };

  const cls = variant === "green"
    ? "bg-brand-success text-white hover:bg-brand-ink"
    : "bg-white hover:bg-brand-yellow";
  const sizeCls = size === "md"
    ? "px-3 py-2 text-xs"
    : "px-2 py-1 text-[11px]";

  return (
    <div ref={wrapRef} className="relative inline-block">
      <button
        type="button"
        data-testid={`${testid}-open`}
        onClick={() => setOpen(o => !o)}
        className={`inline-flex items-center gap-1 border-2 border-brand-ink font-bold uppercase tracking-wide ${cls} ${sizeCls}`}
      >
        <CheckCircle weight="bold" size={size === "md" ? 14 : 12} />
        {label}
        <CaretDown weight="bold" size={10} />
      </button>
      {open && (
        <div
          data-testid={`${testid}-menu`}
          className="absolute z-40 right-0 mt-1 card-brutal bg-white p-1 min-w-[140px]"
        >
          <button
            type="button"
            data-testid={`${testid}-pix`}
            onClick={() => pick("pix")}
            className="w-full text-left px-2 py-2 text-xs font-bold hover:bg-brand-mint flex items-center gap-2"
          >
            <Money weight="bold" size={14} /> Pix
          </button>
          <button
            type="button"
            data-testid={`${testid}-credit`}
            onClick={() => pick("credit")}
            className="w-full text-left px-2 py-2 text-xs font-bold hover:bg-brand-yellow flex items-center gap-2"
          >
            <CreditCard weight="bold" size={14} /> Cartão de crédito
          </button>
        </div>
      )}
    </div>
  );
}

export const METHOD_LABEL = { pix: "Pix", credit: "Cartão" };
